import Router from "./../../router";
import Store from "./../index";
import { db } from "@/firebase";

const InvoiceStore = {
  state: {
    selectedInvoice: null,
    invoices: null,
    cacheInvoices: null
  },

  mutations: {
    SET_INVOICES(state, invoices) {
      state.invoices = invoices;
      state.cacheInvoices = JSON.stringify(invoices);
    },
    SYNC_CACHED_INVOICES_BY_ID(state, invoice) {
      let temp = JSON.parse(state.cacheInvoices);
      temp[invoice.index] = invoice
      state.cacheInvoices = JSON.stringify(temp)
    },
    SET_SELECTED_INVOICE(state, invoice) {
      state.selectedInvoice = invoice;
    },
    ADD_INVOICE(state, params) {
      params.invoice.id = params.ref.id;
      state.invoices.unshift(params.invoice);
    },
    UPDATE_INVOICE(state, params) {
      state.invoices[params.invoice.index] = params.invoice
    },
    DELETE_INVOICE(state, invoice) {
      state.invoices.splice(state.invoices.indexOf(invoice), 1);
    }
  },

  getters: {
    invoices: state => state.invoices,
    cacheInvoices: state => state.cacheInvoices,
    selectedInvoice: state => state.selectedInvoice,
    invoiceById: state => id => {
      if (state.invoices){
        return state.invoices.filter(invoice => {
          return invoice.id === id;
        })[0];
      }
    },
    invoicesByClient: state => id => {
      if (state.invoices){
        return state.invoices.filter(invoice => {
          return invoice.client_id === id;
        });
      }
    }
  },

  actions: {
    getInvoices({ commit }, organisation) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(organisation)
          .collection("invoices")
          .orderBy("number", "desc")
          .get()
          .then(
            querySnapshot => {
              let data = [];
              let index = 0;
              querySnapshot.forEach(function(doc) {
                let obj = doc.data();
                obj.id = doc.id;
                obj.index = index;

                if (obj.date.seconds) { obj.date = (obj.date.seconds * 1000) }
                obj.date = new Date(obj.date)

                for (let article of obj.articles) {
                  if(article.date) {
                    if (article.date.seconds) { article.date = (article.date.seconds * 1000) }
                    article.date = new Date(article.date)
                  }
                }

                data.push(obj);
                index++;
              });
              commit("SET_INVOICES", data);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    addInvoice({ commit }, invoice) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("invoices")
          .add(invoice)
          .then(function(ref) {
            commit("ADD_INVOICE", { ref: ref, invoice: invoice });
            commit("SET_SELECTED_INVOICE", invoice);
            Router.push({ name: "invoices-view", params: { id: invoice.id } });
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    updateInvoice({ commit }, invoice) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("invoices")
          .doc(invoice.id)
          .set(invoice)
          .then(function() {
            commit("UPDATE_INVOICE", { invoice: invoice });
            Store.dispatch("addFlashMessage", { type: "success", message: "Invoice saved!", icon: "fa-monkey", closable: true, timeout: 5000 });
            resolve(invoice)
          })
          .catch(function(error) {
            Store.dispatch("addFlashMessage", { type: "error", message: "Something went wrong while saving!", icon: "fa-monkey", closable: true });
            reject(error);
          });
      });
    },
    deleteInvoice({ commit }, invoice) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("invoices")
          .doc(invoice.id)
          .delete()
          .then(function() {
            commit("DELETE_INVOICE", invoice);
            commit("SET_SELECTED_INVOICE", InvoiceStore.state.invoices[0]);
            Router.push({
              name: "invoices-view",
              params: { id: InvoiceStore.state.invoices[0].id }
            });
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    setSelectedInvoice({ commit, getters }, {invoice, organisation}) {
      let org = organisation || Store.getters.currentUser.organisation
      let invoiceToSet = null;
      if (InvoiceStore.state.invoices) {
        if (typeof invoice === "string") {
          invoiceToSet = getters.invoiceById(invoice);
        } else {
          invoiceToSet = invoice;
        }
      } else {
        if (typeof invoice === "string") {
          return new Promise((resolve, reject) => {
            db.collection("organisations")
              .doc(org)
              .collection("invoices")
              .doc(invoice)
              .get()
              .then(doc => {
                commit("SET_SELECTED_INVOICE", doc.data());
              })
              .catch(function(error) {
                reject(error);
              });
          });
        }
      }
      commit("SET_SELECTED_INVOICE", invoiceToSet);
    },
    syncCachedInvoicesById({ commit }, invoice) {
      commit("SYNC_CACHED_INVOICES_BY_ID", invoice);
    }
  }
};

export default InvoiceStore;
